@if (products$ | async; as products) {
  <div class="my-2 px-2" [ngClass]="{ hidden: products.length === 0 }">
    <div class="mb-2 flex justify-between">
      <div class="flex items-center gap-1">
        <h1 class="text-lg font-semibold">
          {{ title }}
        </h1>
        <ng-content select="[title]"></ng-content>
      </div>
      <a
        class="btn btn-ghost btn-xs text-sm text-slate-400"
        [routerLink]="['/products']"
        [queryParams]="{
          types: queryTypes().length ? queryTypes() : queryType(),
          'flash-sale': flashSale()
        }">
        Xem thêm
      </a>
    </div>
    <div class="bg-base-200 px-1 py-2">
      <market-carousel-wrapper [options]="options">
        @for (item of products; track item.id) {
          <li class="splide__slide p-1">
            <div
              class="cursor-pointer overflow-hidden rounded bg-primary-content shadow">
              <market-carousel-product-item
                [product]="item"
                (addToCart)="
                  onAddToCartHandler($event, dialog)
                "></market-carousel-product-item>
            </div>
          </li>
        }
      </market-carousel-wrapper>
    </div>
  </div>
}
@if (loading()) {
  <market-carousel-product-skeleton [title]="title" [queryType]="queryType()" />
}
<market-add-to-cart-bottom-up #dialog></market-add-to-cart-bottom-up>
